import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Commodity } from '@portal-front-end/models';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { API_SERVER_TOKEN } from '../api-server-token';

@Injectable({ providedIn: 'root' })

export class CommodityApiService {

    constructor(
        private readonly http: HttpClient,
        @Inject(API_SERVER_TOKEN) private apiServer: string
    ) { }

    private readonly COMMODITY_URL = `${this.apiServer}/commodity`;

    getCommodities(): Observable<Commodity[]> {
        return this.http.get<Commodity[]>(this.COMMODITY_URL);
    }
}
